// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"6189df4e","453":"2f7eddc9"}[chunkId] + ".chunk.js";
};